import * as React from 'react';
import { NotTranslated, T } from '../../../Translations';
import { PreviewState } from './Types';

interface Props {
  state: PreviewState;
}

const PreviewPane: React.FC<Props> = ({ state }) => (
  <div className="flex flex-col h-full min-h-0">
    <div className="flex items-center justify-between pb-2 border-b border-border">
      <span
        className="uppercase tracking-wide text-muted-foreground"
        style={{ fontSize: 'var(--text-xs)', fontWeight: 'var(--font-weight-semibold)' }}
      >
        <T kind="Live preview" />
      </span>
      {state.kind === 'ready' && (
        <span className="text-muted-foreground" style={{ fontSize: 'var(--text-xs)' }}>
          <NotTranslated
            text={`${state.preview.sampleParticipant.firstName} ${state.preview.sampleParticipant.lastName}`}
          />
        </span>
      )}
    </div>
    {state.kind === 'ready' && (
      <>
        <p
          className="py-2 text-foreground border-b border-border truncate"
          style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
        >
          {state.preview.subject}
        </p>
        {state.preview.unreplacedTokens.length > 0 && (
          <div className="py-2 flex flex-wrap items-center gap-1.5">
            <span className="text-destructive" style={{ fontSize: 'var(--text-xs)' }}>
              <T kind="These tokens will not be replaced for this communication" />
            </span>
            {state.preview.unreplacedTokens.map((token) => (
              <code
                key={token}
                className="px-1.5 py-0.5 rounded bg-muted text-muted-foreground"
                style={{ fontSize: 'var(--text-xs)' }}
              >
                {token}
              </code>
            ))}
          </div>
        )}
        {state.preview.conditionalTokens.length > 0 && (
          <div className="py-2 flex flex-wrap items-center gap-1.5">
            <span className="text-muted-foreground" style={{ fontSize: 'var(--text-xs)' }}>
              <T kind="These vary by participant and are empty in this sample" />
            </span>
            {state.preview.conditionalTokens.map((token) => (
              <code
                key={token}
                className="px-1.5 py-0.5 rounded bg-muted text-muted-foreground"
                style={{ fontSize: 'var(--text-xs)' }}
              >
                {token}
              </code>
            ))}
          </div>
        )}
        {/* The email shell lays out at 700px; render the frame at full width
            and scale it down to fit the pane so nothing is clipped. */}
        <div
          className="mt-2 overflow-hidden rounded border border-border bg-background"
          style={{ height: 540 }}
        >
          <iframe
            style={{
              width: 720,
              height: 675,
              border: 0,
              transform: 'scale(0.8)',
              transformOrigin: 'top left',
            }}
            sandbox=""
            srcDoc={state.preview.html}
            title="Communication preview"
          />
        </div>
      </>
    )}
    {state.kind === 'loading' && (
      <p className="py-4 text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
        <T kind="Loading..." />
      </p>
    )}
    {state.kind === 'errored' && (
      <p className="py-4 text-destructive" style={{ fontSize: 'var(--text-sm)' }}>
        <T kind="Something went wrong" />
      </p>
    )}
  </div>
);

export default PreviewPane;
